import { render, staticRenderFns } from "./BandejaBorradores.vue?vue&type=template&id=2837ae62&scoped=true"
import script from "./BandejaBorradores.vue?vue&type=script&lang=js"
export * from "./BandejaBorradores.vue?vue&type=script&lang=js"
import style0 from "./BandejaBorradores.vue?vue&type=style&index=0&id=2837ae62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2837ae62",
  null
  
)

export default component.exports